import React from 'react'
import './ContactUs.scss';
import Header from '../common/Header/Header';
import Footer from '../common/Footer/NewFooter';
import ContactLanding from './ContactLanding'
import ContactForm from './ContactForm';
import { useLocation } from "react-router-dom"

const ContactUs = () => {
  let location = useLocation();
  let Title = 'CausalFunnel Free Trial';
  let SubTitle = 'Get In Touch!';
  let SubDesc = 'Fill in the details below and get started on the free trial.'
  let btnText = 'Start Free Trial'
  // console.log(location.pathname);
  let currentUrl = location.pathname;
  if (currentUrl === '/contact-us') {
    Title = 'We love hearing from you';
    SubTitle = 'Get in touch with us '
    SubDesc = 'Fill in the details below and Our team will get back to you.'
    btnText = 'Submit'
  } 
  return (
    <div id='contact-us'>
      <Header />
      <ContactLanding title={Title}/>
      <ContactForm title={SubTitle} desc={SubDesc} btnText={btnText} url={currentUrl }/>
      <Footer />
    </div>
  )
}

export default ContactUs